import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../hooks';
import { AvailabilityResponse, CareModel } from '../types';
import qs from 'qs';

export const useProviderAvailability = ({
  care_model,
  end_date,
  start_date,
  timezone,
  user_id,
}: {
  care_model?: CareModel;
  end_date?: string;
  start_date?: string;
  timezone?: string;
  user_id?: string;
}) => {
  const { api } = useApi();

  const fetchAvailability = async (): Promise<AvailabilityResponse> => {
    const queryStr = qs.stringify({
      end_date,
      start_date,
      timezone,
      user_id,
    });

    return api({
      route: `/care_team_member/availability${queryStr ? `?${queryStr}` : ''}`,
    });
  };

  const { data, isInitialLoading, isLoading, isError } = useQuery<
    AvailabilityResponse,
    Error
  >({
    queryKey: ['public-provider-availability', start_date, end_date],
    queryFn: fetchAvailability,
    enabled: care_model === CareModel.Collaborative && !!timezone && !!user_id,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading: isInitialLoading || isLoading,
    isError,
    data,
  };
};
